module.exports = __webpack_public_path__ + "img/control-switch-off.b54f2904.svg";